import { Toaster } from '@/shared/components/ui/sonner'

/** Sonner 宿主 — 全站 toast 由 notify.ts → sonner 驱动 */
export function ToastHost() {
  return <Toaster richColors closeButton />
}
